module.exports = __webpack_public_path__ + "img/123.7476e78a.jpg";